<template>
  <q-select
    rounded
    outlined
    dense
    v-model="selectedAiTemplate"
    :options="aiTemplates"
    option-value="id"
    option-label="name"
    class="full-width"
    @update:model-value="selectAiTemplate"
  />
</template>

<script setup>
import { useCurrentOrganization } from '@/hooks/useCurrentOrganization';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

const LOCAL_STORAGE_KEY = 'cachedAiTemplateId';
const $store = useStore();
const aiTemplates = computed(() => $store.getters.currentOrganization.aiTemplates);
const selectedAiTemplate = ref(null);
const emit = defineEmits(['onSelect']);

const props = defineProps({
  selectedAiTemplateId: {
    type: String,
    default: null,
  },
  cache: {
    type: Boolean,
    default: false,
  },
  uid: {
    type: String,
    required: false,
  },
});

const {} = useCurrentOrganization({
  onOrganizationChange: (_, { getTeamByUid }) => {
    const teamDefaultAiTemplateId = getTeamByUid(props.uid)?.defaultAiTemplateId;
    selectedAiTemplate.value =
      aiTemplates.value.find(
        ({ id }) =>
          (props.selectedAiTemplateId ||
            teamDefaultAiTemplateId ||
            $store.getters.currentOrganization?.defaultAiTemplate) === id
      ) || aiTemplates.value[0];
  },
});

const selectAiTemplate = (aiTemplate) => {
  props.cache && localStorage.setItem(LOCAL_STORAGE_KEY, aiTemplate.id);
  emit('onSelect', aiTemplate);
};
</script>

<style scoped lang="scss">
.q-btn--outline:before {
  border-color: $grey-5;
}
</style>
